import classNames from 'classnames';
import { Media, Rollover } from "../../components/index.mjs";
import { jsx as _jsx } from "react/jsx-runtime";
export function GalleryImage(_ref) {
  var {
    originalImage,
    previewImage,
    onClick: _onClick,
    rounded = false,
    style
  } = _ref;
  return /*#__PURE__*/_jsx(Rollover, {
    id: "gallery-image-".concat(originalImage.uuid),
    className: classNames('prezly-slate-gallery-image', {
      'prezly-slate-gallery-image--with-border-radius': rounded
    }),
    caption: originalImage.caption,
    href: originalImage.cdnUrl,
    onClick: () => _onClick(originalImage),
    style: style,
    children: /*#__PURE__*/_jsx(Media, {
      className: "prezly-slate-gallery-image__media",
      image: previewImage,
      title: originalImage.caption
    })
  });
}